module.exports = __webpack_public_path__ + "static/img/applet.50749e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/applet.jpg
// module id = q6tc
// module chunks = 0